import { Panel } from "../../components/panels/Panel";
import { ImageWithBbox } from "../gallery/snapshots/ImageWithBbox";
import { PhotoIcon, PlusIcon } from "@heroicons/react/20/solid";
import { postData, useGetData } from "../../services/api/api-tools";
import { Loader } from "../../components/loading/Loader";
import { useState } from "react";
import { Modal } from "../../components/modals/Modal";
import { loadLayout, loadLayoutData } from "../../services/ergonomics/ergonomics-service";
import { formatSecondsToFullDateTime } from "../../helpers/date/date-helper";
import { useEffect } from "react";


export const AuditSummaryPage = () => {

  const [selectedAudit, setSelectedAudit] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState('');

  const token = localStorage.getItem('token');
  if (!token) return null;

  const audits = useGetData('audits', 'audits');

  const handleSelectAudit = (audit) => {
    if (audit.status === 1) {
      setSelectedAudit(audit);
    }
    else {
      setSelectedAudit(null);
    }
  };

  const handleValueChange = (e) => {
    setValue(e.target.value);
  };

  const closeModal = () => {
    setValue('');
    setIsOpen(false);
  };

  const saveAudit = async () => {
    try {
      const body = {
        name: value,
        status: 0,
        creationDate: Math.floor(Date.now() / 1000),
      }
      const response = await postData('audits', body);
      await audits.refetch();
    } catch (error) {
      console.error('Error creating new audit in database.', error);
      return null;
    }
  };

  if (audits.isLoading) return <Loader/>;

  return (
    <div className='flex h-full'>
      <Modal isOpen={isOpen} setIsOpen={closeModal}>
        <div className='p-4'>
          <h3 className='text-lg text-start font-medium leading-6 text-gray-900'>Request details</h3>
          <div className='my-4'>
            <input type="text" placeholder="Name of the request" className="bg-gray-200 p-2 rounded-sm w-full" value={value} onChange={handleValueChange} />
          </div>
          <div className="flex my-4">
            <p>Supplier: </p>
            <select className="bg-perception-gray-100 rounded-md px-2 py-1 ml-4">
              <option value="#">Supplier #1</option>
            </select>
          </div>
          <div className='flex justify-start'>
            <button
              className='inline-flex justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50'
              onClick={closeModal}
            >
              Cancel
            </button>
            <button
              className='ml-4 inline-flex justify-center rounded-md border border-transparent bg-perception-blue px-4 py-2 text-sm font-medium text-white shadow-sm'
              onClick={() => {
                saveAudit();
                closeModal();
              }}
              disabled={value === ''}
            >
              Create
            </button>
          </div>
        </div>
      </Modal>

      <div className='w-2/3'>
        <Panel category='main' title='AUDITS LIST' noPadding={true}>
          <div className="flex justify-center items-center p-8">
            <button className="bg-perception-blue text-white p-4 rounded-md flex items-center" onClick={() => setIsOpen(true)}>
              <PlusIcon aria-hidden="true" className="size-5 mr-2" /> Create a new request
            </button>
          </div>
          <div>
            {
              audits.data.sort((a, b) => b.id - a.id).map((audit, index) => {
                const bgColor = audit.status === 0 ? 'bg-perception-black-700' : 'bg-perception-black-500';
                return (
                  <div key={index} className={`p-4 ${bgColor} flex items-center gap-4 text-white cursor-pointer`}
                       onClick={() => handleSelectAudit(audit)}>
                    {
                      audit.status === 0 ?
                        <div className="bg-perception-warn-500 px-2 py-1 rounded-md text-base text-white">WAITING</div> :
                        <div className="bg-perception-success-300 px-2 py-1 rounded-md text-base text-white">OK</div>
                    }
                    {audit.name}
                  </div>
                )
              })
            }
          </div>
        </Panel>
      </div>
      <div className="w-1/3">
        <Panel title='&nbsp;' noPadding={true}>
          {
            selectedAudit === null ?
              <div className='h-full flex flex-col gap-4 justify-center items-center text-center p-8'>
                <PhotoIcon className='size-16 text-perception-black-700' />
                <div className='text-perception-gray-700 text-xl'>Select a completed audit to view the result</div>
              </div>
              :
              <div>
                <div className="text-xl flex flex-col gap-4 p-4">
                  <p>Supplier: Supplier #1</p>
                  <p>Location: {selectedAudit.completion_location || 'Unknown'}</p>
                  <p>Created: {formatSecondsToFullDateTime(selectedAudit.creation_date)}</p>
                  <p>Completed: {formatSecondsToFullDateTime(selectedAudit.completion_date)}</p>
                </div>
                <ImageWithBbox points={[]} src={process.env.REACT_APP_ADDRESS + 'public/media/' + selectedAudit.file_name} />
              </div>
          }
        </Panel>
      </div>
    </div>
  );
};